<template>
  <div class="trust">
    <div class="container">
      <!-- <h4 class="trust-title">НАМ ДОВЕРЯЮТ</h4> -->
      <h4
        class="trust-title"
        v-html="trustTitle"
      />
      <swiper
        :slides-per-view="5"
        :space-between="10"
        :free-mode="true"
        :centered-slides="false"
        :autoplay="{
          delay: 1500,
          reverseDirection: true,
          disableOnInteraction: false,
        }"
        :pagination="false"
        :navigation="false"
        :modules="modules"
        class="mySwiper"
      >
        <!-- <swiper-slide>
                    <div class="box">
                        <h5>И ЕЩЕ <br> 20 ТЫСЯЧ <br> КОМПАНИЙ</h5>
                    </div>
                </swiper-slide> -->
        <swiper-slide
          v-for="tr in trust"
          :key="tr"
        >
          <div class="box">
            <img
              :src="cdn + tr.icon"
              alt=""
            >
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>


import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import axios from 'axios'
import {mapState} from 'vuex';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
        modules: [Autoplay, Pagination, Navigation],
        };
    },
    data() {
        return {
            trust: null,
            trustTitle: [],
            errors: [],
        }
    },
    computed :{
        ...mapState(['cdn']),
    },
    created() {
        axios.get('V1/partners')
        .then(response => {
            this.trust = response.data.data
            this.trustTitle = response.data.data[0].title
        })
        .catch(e => {
            this.errors.push(e)
        })
    },
};
</script>

<style lang="scss" scoped>
@mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
    font-family: $family;
    font-style: normal;
    font-weight: $weight;
    font-size: $size;
    line-height: $lheight;
    color: $color;
}
@mixin mobile {
    @media(min-width: 320px) and (max-width: 425px) {
        @content;
    }
}
@mixin tablet {
    @media(min-width: 425px) and (max-width: 767px) {
        @content;
    }
}
@mixin tablet-1024 {
    @media(min-width: 767px) and (max-width: 1024px) {
        @content;
    }
}
@mixin desktop {
    @media(min-width: 1024px) and (max-width: 1440px) {
        @content;
    }
}
@mixin desktop-max {
    @media(min-width: 1620px) and (max-width: 2560px) {
        @content;
    }
}
.trust {
    background: #EFEFEF;
    padding-top: 75px;
    padding-bottom: 40px;
    &-title {
        @include fontStyle(Roboto, normal, 500, 28px, 34px, #373737);
        letter-spacing: 0.03em;
        text-transform: uppercase;
        padding-bottom: 40px;
    }
    @include mobile() {
        padding-bottom: 10px;
        padding-top: 45px;
        &-title {
            font-size: 14px;
            line-height: 14px;
            padding-bottom: 10px;
        }
    } 
    @include tablet() {
        padding-bottom: 10px;
        padding-top: 45px;
        &-title {
            font-size: 16px;
            line-height: 19px;
            padding-bottom: 15px;
        }
    }
}
.box {
    width: 233px;
    height: 233px;
    background: #FFFFFF;
    border-radius: 15px;
    h5 {
        @include fontStyle(Roboto, normal, 500, 24px, 31px, #000000);
        text-transform: uppercase;
        text-align: left;
        padding: 55px 28px;
    }
    img {
        max-width: 170px;
        width: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        padding-left: 12px;
        padding-right: 12px;
    }
    @include mobile() {
        width: 64px;
        height: 64px;
        h5 {
            font-size: 6px;
            line-height: 7px;
            padding: 10px 5px;
        }
        img {
            padding-left: 3px;
            padding-right: 3px;
        }
    }
    @include tablet() {
        width: 72px;
        height: 72px;
        h5 {
            font-size: 8px;
            line-height: 10px;
            padding: 10px 5px;
        }
        img {
            padding-left: 3px;
            padding-right: 3px;
        }
    }
    @include tablet-1024() {
        height: 130px;
        h5 {
            font-size: 13px;
            line-height: 15px;
            padding: 10px 5px;
        }
    }
}
.swiper {
    width: 100%;
    height: 100%;
}
.swiper-slide {
    border-radius: 15px;
    text-align: center;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    @include mobile() {
        border-radius: 3px;
    }
    @include tablet() {
        border-radius: 5px;
    }
}
// .swiper-slide img {
//     display: block;
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
// }
</style>
